import { Address } from "./address.model";
import { FirestoreDataConverter } from "@angular/fire/firestore";

export class WebOrderModel {
  public id = '';
  public organizationId = '';
  public reference = '';
  public shop = '';
  public user = '';
  public date: Date|null = new Date();
  public invoicing!: Address | null;
  public subTotal = 0;
  public taxes = 0;
  public delivery = 0;
  public transport = 0;
  public total = 0;
  public lang = '';
  public paid = false;
  public paymentCustomer = '';
  public paymentId = '';
  public invoiced: boolean;
  public invoiceUrl: string;
  public invoiceNumber: string;
  public isQuotation: boolean;

  constructor(data?: Partial<WebOrderModel>) {
    this.id = data?.id ?? '';
    this.organizationId = data?.organizationId ?? '';
    this.reference = data?.reference ?? '';
    this.shop = data?.shop ?? '';
    this.user = data?.user ?? '';
    this.date = data?.date ?? new Date();
    this.invoicing = data?.invoicing ? new Address(data.invoicing) : null;
    this.subTotal = data?.subTotal ?? 0;
    this.taxes = data?.taxes ?? 0;
    this.delivery = data?.delivery ?? 0;
    this.transport = data?.transport ?? 0;
    this.total = data?.total ?? 0;
    this.lang = data?.lang ?? 'en';
    this.paid = data?.paid ?? false;
    this.paymentCustomer = data?.paymentCustomer ?? '';
    this.paymentId = data?.paymentId ?? '';
    this.invoiced = data?.invoiced ?? false;
    this.invoiceUrl = data?.invoiceUrl ?? '';
    this.invoiceNumber = data?.invoiceNumber ?? '';
    this.isQuotation = data?.isQuotation ?? false;
  }

  /**
   * Converter used to convert a web order from firebase
   */
  static converter: FirestoreDataConverter<WebOrderModel> = {
    toFirestore: order => ({
      id: order.id,
      organizationId: order.organizationId,
      reference: order.reference,
      shop: order.shop,
      user: order.user,
      date: order.date,
      invoicing: order.invoicing,
      subTotal: order.subTotal,
      taxes: order.taxes,
      delivery: order.delivery,
      transport: order.transport,
      total: order.total,
      lang: order.lang,
      paid: order.paid,
      paymentCustomer: order.paymentCustomer,
      paymentId: order.paymentId,
      invoiced: order.invoiced,
      invoiceUrl: order.invoiceUrl,
      invoiceNumber: order.invoiceNumber,
      isQuotation: order.isQuotation,
    }),
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new WebOrderModel({
        ...snapshot.data(options),
        id: snapshot.id,
        date: data["date"] ? new Date(data["date"].seconds * 1000) : null,
      })
    }
  };
}
